<!--
component: BrowseDaichoKakuShin.vue
author: Kota Izumi 
description: 確認申請台帳閲覧画面
-->
<template>
  <section>
    <div class="split">
      <div class="split left-box" v-show="$vuetify.breakpoint.name != 'xs'">
        <v-btn  @click="openOutputDialog"
          color="#bb7755" large width="90%" style="color: white;"
          class="text-h6 ml-2 my-1"
          :disabled="isMadoguchi">
          <v-icon color="#dddddd" class="mx-1">mdi-download</v-icon>
          申請書出力
        </v-btn>
        <div style="width: 90%;margin: 8px auto;" v-if="!isMadoguchi">
          公印が押印された証明書を<br>取得をご希望の方は<br>このボタンから<br>申請書をダウンロードしてください
        </div>
      </div>

      <div id="content" class="split right-box" :style="$vuetify.breakpoint.name == 'xs'? 'width:90%':''" v-if="kisaiData">
        <KakuShinKisaiPreview :data="ledgerData" v-if="!printComponent"/>
        <KakuShinKisaiPrint :data="ledgerData" v-if="printComponent" />
      </div>

      <div id="content" class="split right-box" :style="$vuetify.breakpoint.name == 'xs'? 'width:90%':''" v-if="kamiData">
        <KakuShinKamiPreview :data="ledgerData" v-if="!printComponent"/>
        <KakuShinKamiPrint :data="ledgerData" v-if="printComponent"/>
      </div>

    </div>

    <v-btn
      v-show="$vuetify.breakpoint.name == 'xs'"
      @click="menuToggle = !menuToggle"
      color="rgb(88, 132, 163)"
      dark
      x-small
      class="px-0"
      max-width="3%"
      height="10%"
    >
      <v-icon>mdi-chevron-double-right</v-icon>
    </v-btn>
    <v-navigation-drawer
      v-model="menuToggle"
      absolute
      temporary
      color="rgb(198, 226, 225)"
    >
      <div class="px-2">
        <v-container fluid>
          <v-row>
            <ZoomCanvas id="zoom-area" width="300" heigth="200"
              style="margin:5px;"
              :sourceImage="image" :zoom="zoomScale"
              :centerx="zoomCenterX" :centery="zoomCenterY"
            />
          </v-row>
          <v-row>
            <v-btn  @click="openOutputDialog"
              dark color="#bb7755" large width="90%"
              class="text-h6 ml-2 my-1">
              <v-icon color="#dddddd" class="mx-1">mdi-download</v-icon>
              申請書出力
            </v-btn>
            <div style="width: 90%;margin: 8px auto;">
              公印が押印された証明書を<br>取得をご希望の方は<br>このボタンから<br>申請書をダウンロードしてください
            </div>
          </v-row>

        </v-container>
      </div>
    </v-navigation-drawer>

    <v-dialog :width="dialogWidth" v-model="isOpenOutputDialog" persistent class="custom-dialog">
      <v-card>
        <v-card-title>
          <p class="dialog-title">ダウンロードが完了しました</p>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-row class="ma-1">
            <v-col style="width:100%;">
              <p>
                <span style="color: red; padding: 0px;">申請書データは端末のダウンロードファイルに保存されています。</span><br>
                電子申請は完了していません。<br>
                ダウンロードした電子申請書を横浜市電子申請・届出システム(https://shinsei.city.yokohama.lg.jp/cu/141003/ea/residents/portal/home)に申請添付してください。
              </p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pt-1">
          <v-btn class="custom-btn" @click="closeOutputDialog">概要書表示画面に戻る</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="custom-btn" @click="goYokohamashiPage">横浜市電子申請・届出システムを開く</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
  import ZoomCanvas from '@components/ZoomCanvas.vue'
  import KakuShinKisaiPreview from '@components/kakushin/KakuShinKisaiPreview.vue'
  import KakuShinKisaiPrint from '@components/kakushin/KakuShinKisaiPrint.vue'
  import KakuShinKamiPreview from '@components/kakushin/KakuShinKamiPreview.vue'
  import KakuShinKamiPrint from '@components/kakushin/KakuShinKamiPrint.vue'
  import { apiUrl, dbglog, getWardCodeBalicsShortname } from '@common/utils'
  import { callGetApi, registLog } from '@common/apiAccess'

  export default {
    components: {
      ZoomCanvas,
      KakuShinKisaiPreview,
      KakuShinKisaiPrint,
      KakuShinKamiPreview,
      KakuShinKamiPrint,
    },
    data: () => {
      return {
        ledgerData:{
          constructType: [],
          rcpNo: '',
          cnfNo: '',
          issue:{
            no: null,
            date: '',
            person: '',
            ledgerType: '確認申請台帳',
          },
          build:{
            gaiyo:{
              placeLotNo: '',
              mainUse: '',
              siteArea: null,
              buildAreaApp: null,
              buildAreaNotApp: null,
              totalAreaApp: null,
              totalAreaNotApp: null,
              struct: '',
              ground: null,
              underGround: null,
              buildNum: null,
            },
            architectInfo:{
              address: '',
              company: '',
              position: '',
              name: '',
              joinNum: null,
              joinPerson: [],
            },
            comment: '',
          },
          kknnNo: null,
          kknnDay: null,
          ukeNo: null,
          ukeDay: null,
          henkoNo: null,
          henkoDay: null,
          chukanNo1: null,
          chukanDay1: null,
          chukanNo2: null,
          chukanDay2: null,
          kenzumiNo: null,
          kenzumiDay: null,
        },

        currentPage: 0,
        error: 0,
        browseLimitOver: false,
        image: null,    // オリジナル画像オブジェクト
        imageWidth: 0,  // オリジナル画像の幅
        imageHeight: 0, // オリジナル画像の高さ
        viewerRatio: 1, // 部分拡大窓の拡大率
        zoomScale: 1,   // ZoomImageViewerに渡すスケール値
        zoomCenterX: 0, // ZoomImageViewerに渡す画像中心X座標
        zoomCenterY: 0, // ZoomImageViewerに渡す画像中心Y座標
        updateCount: 0,
        
        isOpenOutputDialog: false,
        dialogWidth: '50%',
        menuToggle: false,
        // pdf用date YYYYMMDD 形式
        today: null,

        printComponent: false,
        isMadoguchi: false,
      };
    },
    computed: {
      mode: {
        get(){ return this.$store.state.mode; },
        set(val){ this.$store.commit('setMode', val); }
      },
      gaiyo (){
        return this.$store.state.gaiyoData;
      },
      date: {
        get(){
          return this.ledgerData.issue.date;
        },
        set(val){
          this.ledgerData.issue.date = val;
          //年度内開庁日の連番を取得し格納
          const url = apiUrl('KisaiNo') + '?date=' + val;
          callGetApi(url, (data) => {
            if (data.errorCode === undefined){
              this.ledgerData.issue.no = data;
            }
          });
        }
      },
      kamiData() {
        return this.$store.state.kamiData;
      },
      kisaiData() {
        return this.$store.state.kisaiData;
      }
    },
    mounted(){
      if (this.unauthorized){
        this.authDialog = true;
      }
      this.$store.commit('setCurrentPage', 3);

      // ges,m_gaiyoからのデータ(kisaiData)かbalics(紙台帳)からのデータ(kamiData)かを判定
      if (this.kisaiData) {
        dbglog(`ges,m_gaiyoからのデータをマッピング: ${this.kisaiData}`);
        const dbData = this.kisaiData;
        // APIで取得したデータをセット
        this.ledgerData.rcpNo = dbData.ukeNo != null ? dbData.ukeNo : '';
        this.ledgerData.cnfNo = dbData.kknnNo != null ? dbData.kknnNo : '';
        this.ledgerData.ukeNo = dbData.ukeNo != null ? dbData.ukeNo : '';
        this.ledgerData.ukeDay = dbData.ukeDay != null ? this.convDate(dbData.ukeDay) : '';
        this.ledgerData.issue.no = dbData.hakkoNo != null ? dbData.hakkoNo : '';
        this.ledgerData.issue.date = dbData.hakkoDate != null ? dbData.hakkoDate.replaceAll('/','-') : '';
        //this.$refs.issueDatePicker.picker = dbData.hakkoDate != null ? dbData.hakkoDate.replaceAll('/','-') : '';
        //this.$refs.issueDatePicker.pickerText = dbData.hakkoDate != null ? dbData.hakkoDate.replaceAll('/','-') : '';
        this.ledgerData.issue.person = dbData.hakkosha != null ? dbData.hakkosha : '';
        this.ledgerData.issue.ledgerType = dbData.ledgerType != null ? dbData.ledgerType : '';
        this.ledgerData.build.gaiyo.placeLotNo = dbData.timeiTiban != null ? dbData.timeiTiban : '';
        this.ledgerData.build.gaiyo.mainUse = dbData.yoto != null ? dbData.yoto : '';
        this.ledgerData.build.gaiyo.siteArea = dbData.shikichi != null ? dbData.shikichi : '';
        this.ledgerData.build.gaiyo.buildAreaApp = dbData.kenmenBubun != null ? dbData.kenmenBubun : 0;
        this.ledgerData.build.gaiyo.buildAreaNotApp = dbData.kenmenIgai != null ? dbData.kenmenIgai : 0;
        this.ledgerData.build.gaiyo.totalAreaApp = dbData.nobemenBubun != null ? dbData.nobemenBubun : 0;
        this.ledgerData.build.gaiyo.totalAreaNotApp = dbData.nobemenIgai != null ? dbData.nobemenIgai : 0;
        this.ledgerData.build.gaiyo.struct = dbData.kozo != null ? dbData.kozo : '';
        this.ledgerData.build.gaiyo.ground = dbData.chijoKaisu != null ? dbData.chijoKaisu : 0;
        this.ledgerData.build.gaiyo.underGround = dbData.chikaKaisu != null ? dbData.chikaKaisu : 0;
        this.ledgerData.build.gaiyo.buildNum = dbData.munesu != null ? dbData.munesu : 0;
        this.ledgerData.build.architectInfo.address = dbData.builderAddr != null ? dbData.builderAddr : '';
        this.ledgerData.build.architectInfo.company = dbData.builderCompany != null ? dbData.builderCompany : '';
        this.ledgerData.build.architectInfo.position = dbData.builderPost != null ? dbData.builderPost : '';
        this.ledgerData.build.architectInfo.name = dbData.builderName != null ? dbData.builderName : '';
        this.ledgerData.build.architectInfo.joinPerson = dbData.renmeisha != null ? dbData.renmeisha : [];
        this.ledgerData.build.comment = dbData.comment != null ? dbData.comment : '';
        this.ledgerData.kknnNo = dbData.orgKknnNo,
        this.ledgerData.kknnDay = this.convDate(dbData.orgKknnDay),
        this.ledgerData.henkoNo = dbData.henkoNo,
        this.ledgerData.henkoDay = this.convDate(dbData.henkoDay),
        this.ledgerData.chukanNo1 = dbData.chukanNo1,
        this.ledgerData.chukanDay1 = this.convDate(dbData.chukanDay1),
        this.ledgerData.chukanNo2 = dbData.chukanNo2,
        this.ledgerData.chukanDay2 = this.convDate(dbData.chukanDay2),
        this.ledgerData.kenzumiNo = dbData.kenzumiNo,
        this.ledgerData.kenzumiDay = this.convDate(dbData.kenzumiDay),
        dbData.shintiku ? this.ledgerData.constructType.push('0') : '';
        dbData.zoutiku ? this.ledgerData.constructType.push('1') : '';
        dbData.kaitiku ? this.ledgerData.constructType.push('2') : '';
        dbData.iten ? this.ledgerData.constructType.push('3') : '';
        dbData.yotohenkou ? this.ledgerData.constructType.push('4') : '';
        dbData.daishuzen ? this.ledgerData.constructType.push('5') : '';
        dbData.daimoyougae ? this.ledgerData.constructType.push('6') : '';

        // 建築主数
        if (dbData.builderName != '' || dbData.builderName != null){
          this.ledgerData.build.architectInfo.joinNum = 1 + (dbData.renmeisha != null ? dbData.renmeisha.length : 0);
        }
        else {
          this.ledgerData.build.architectInfo.joinNum = (dbData.renmeisha != null ? dbData.renmeisha.length : 0);
        }
      }
      else {
        dbglog(`balics(紙台帳)からのデータをマッピング: ${this.kamiData}`);
        const dbData = this.kamiData;
        
        console.log(dbData);

        var sikibetsu = dbData.nen + getWardCodeBalicsShortname(dbData.gyosei_kubun) + dbData.bango;

        this.ledgerData.rcpNo = sikibetsu != null ? sikibetsu : '';
        this.ledgerData.cnfNo = sikibetsu != null ? sikibetsu : '';
        this.ledgerData.issue.no = dbData.bango;
        this.ledgerData.issue.date = this.formatDate(new Date());  // 現在日付をそのまま設定
        this.ledgerData.issue.ledgerType = dbData.ledgerType != null ? dbData.ledgerType : '';
        this.ledgerData.ukeNo = sikibetsu;
        this.ledgerData.ukeDay = this.formatDateWareki(dbData.uke_day);
        this.ledgerData.kknnNo = sikibetsu;
        this.ledgerData.kknnDay = this.formatDateWareki(dbData.kknn_day);
        this.ledgerData.henkoNo = sikibetsu;
        this.ledgerData.henkoDay = this.formatDateWareki(dbData.kknn_day);
        this.ledgerData.chukanNo1 = sikibetsu;
        this.ledgerData.chukanDay1 = this.formatDateWareki(dbData.kenzumi_day);
        this.ledgerData.build.gaiyo.placeLotNo1 = dbData.bkn_addr1;
        this.ledgerData.build.gaiyo.placeLotNo2 = dbData.bkn_addr2;
        this.ledgerData.build.gaiyo.mainUse = dbData.gutai_syuyo_yoto;
        this.ledgerData.build.gaiyo.siteArea = this.setValue(dbData.site_area);
        this.ledgerData.build.gaiyo.buildAreaApp = this.setValue(dbData.bld_area);
        this.ledgerData.build.gaiyo.buildAreaNotApp = dbData.nb_area;
        //this.ledgerData.build.gaiyo.totalAreaApp = this.setValue(dbData.site_area+dbData.bld_area);
        this.ledgerData.build.gaiyo.totalAreaApp = this.setValue(dbData.nb_area);

        this.ledgerData.build.gaiyo.unitSiteArea = dbData.unit_site_area;
        this.ledgerData.build.gaiyo.unitBuildAreaApp = dbData.unit_bld_area;
        this.ledgerData.build.gaiyo.unitTotalAreaApp = dbData.unit_nb_area;

        this.ledgerData.build.gaiyo.constructType = dbData.gutai_koji_sybt;
        this.ledgerData.build.gaiyo.struct = dbData.gutai_kozo_sybt;
        this.ledgerData.build.gaiyo.ground = (dbData.tijo_kaisu || "-");
        this.ledgerData.build.gaiyo.underGround = (dbData.tika_kaisu || "-");
        this.ledgerData.build.gaiyo.buildNum = (dbData.sns_bld_su || "-");
        this.ledgerData.build.architectInfo.address1 = (dbData.bldr_addr1 || "");
        this.ledgerData.build.architectInfo.address2 = (dbData.bldr_addr2 || "");
        this.ledgerData.build.architectInfo.name1 = (dbData.bldr_name1 || "");
        this.ledgerData.build.architectInfo.name2 = (dbData.bldr_name2 || "");
        this.ledgerData.build.architectInfo.joinNum = (dbData.bldr_other_cnt || "-");
        this.ledgerData.flg_kenzumi = dbData.flg_kenzumi;
        //this.ledgerData.build.architectInfo.address = (dbData.bldr_addr1 || "") + (dbData.bldr_addr2 || "");
        //this.ledgerData.build.architectInfo.name = (dbData.bldr_name1 || "")+(dbData.bldr_name2 || "");
        //this.ledgerData.build.architectInfo.joinNum = (dbData.bldr_other_cnt || "0");

        this.setDanchoNo();
      }
      
      console.log('mounted - kisaiData:', this.$store.state.kisaiData);
      console.log('mounted - kamiData:', this.$store.state.kamiData);

      this.today = this.getPdfDate();
      // 申請書PDF出力は html2canvas + jsPDF を使うため、必要なスクリプトを動的に読み込む
      const script = document.createElement('script');
      script.src = "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
      script.onload = () => {
        console.log("jsPDF loaded!");
        // スクリプトがロードされた後に実行されるコードをここに記述
      };
      document.head.appendChild(script);

      const script2 = document.createElement('script');
      script2.src = "https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js";
      script2.onload = () => {
        console.log("html2canvas loaded!");
        // スクリプトがロードされた後に実行されるコードをここに記述
      };
      document.head.appendChild(script2);



      // 閲覧ログ取得
      registLog([[106, '記載証明書確認申請情報閲覧', this.ledgerData.rcpNo, this.ledgerData.cnfNo],]);

      // 窓口端末の判定
      if (this.$store.state.clientInfo.category == 1){
        this.isMadoguchi = true;
      }
    },

    methods: {
      async openOutputDialog(){
        // 申請書印刷: 印字用コンポーネントを一時表示 -> canvas化 -> PDF保存
        this.printComponent = true;
        await this.$nextTick();
        
        // 注意文のHTMLファイル読み込みを待つ
        await new Promise(resolve => setTimeout(resolve, 300));
        
        // 様式1(kami)か様式2(kisai)かを判定して適切なIDを取得
        const sectionId = this.kamiData ? "#print-obj-kami" : "#print-obj-kisai";
        const section1 = document.querySelector(sectionId);
        
        const { jsPDF } = window.jspdf;
        const pdf = new jsPDF();

        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        const canvas1 = await window.html2canvas(section1, { scale: 1 });
        const imgData1 = canvas1.toDataURL('image/png');
        this.printComponent = false;
        pdf.addImage(imgData1, 'PNG', 0, 0, pdfWidth, pdfHeight);

        registLog([[105, '記載証明書確認申請書ダウンロード', this.ledgerData.rcpNo, this.ledgerData.cnfNo],]);

        // PDFを保存
        pdf.save(`${this.today}_${this.ledgerData.rcpNo}.pdf`);
        this.isOpenOutputDialog = true;
      },

      closeOutputDialog(){
        this.isOpenOutputDialog = false;
      },

      goYokohamashiPage(){
        window.open('https://shinsei.city.yokohama.lg.jp/cu/141003/ea/residents/portal/home/', '_blank')
      },

      // pdf用date YYYYMMDD 形式
      getPdfDate(){
        const date = new Date();
        const year = date.getFullYear() % 100;
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}${month}${day}`;
      },

      // 建築主数更新処理および連名者氏名入力制御
      updateJoinNum(){
        // if (this.ledgerData.build.architectInfo.joinPerson.length <= 10){
        if (this.ledgerData.build.architectInfo.name != ''){
          this.ledgerData.build.architectInfo.joinNum = 1 + this.ledgerData.build.architectInfo.joinPerson.length;
        }
        else {
          this.ledgerData.build.architectInfo.joinNum = this.ledgerData.build.architectInfo.joinPerson.length;
        }
        /*
        }
        else {
        this.ledgerData.build.architectInfo.joinPerson.pop();
        }
        */
      },

      // 日付変換処理(0埋めで来る値を空白に変換 ex:平成09年12月01日 → 平成 9年12月 1日)
      convDate(date){
        if (date == '' || date == null) {
          return '';
        }

        const text = String(date);
        const match = text.match(/^(.*?)(元|\d+)年(\d{1,2})月(\d{1,2})日$/);
        if (!match) {
          return text;
        }

        const era = match[1];
        const year = match[2];
        const month = match[3].padStart(2, ' ');
        const day = match[4].padStart(2, ' ');
        return `${era}${year}年${month}月${day}日`;
      },

      addFooter(){
        /* 2026/01/20 フッター未使用のため停止
        const target = document.getElementById(targetId);
        if (target && target.querySelector('.footer-area')) {
          return;
        }
        var footer = document.createElement('Footer');
        footer.setAttribute('style', 'text-align:center;color: black !important;background-color:#FFFF !important;bottom: 0px;position:absolute;width:100%;font-size:11pt !important;font-family: "MS PGothic",sans-serif;');
        footer.appendChild(document.createTextNode('注意：この資料は、横浜市が保有する台帳から、建築物の情報を抜粋したものであり、'));
        footer.appendChild(document.createElement('br'));
        footer.appendChild(document.createTextNode('建築物の現況や、建築確認時の内容（建築計画概要書等）と異なる場合があります。(' + this.ledgerData.rcpNo + ')'));
        target.appendChild(footer);
        */
      },

      formatDate(date){
        if(date != '' && date != null){
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0'); // 月は0から始まるため、1を加えます
          const day = String(date.getDate()).padStart(2, '0');
          const formattedDate = `${year}-${month}-${day}`;
          return formattedDate;
        }
        else {
          return '';
        }
      },
      formatDateWareki(date_str) {
        if(!date_str) return "記載なし";
        date_str = date_str.split('T')[0];
        let [year, month, day] = date_str.split('-');
        if (typeof month === 'undefined' || month === '') {
          return "記載なし";
        }
        if (typeof day === 'undefined' || day === '') {
          return "記載なし";
        }
        month = ('00' + month).slice(-2).replace(/^0/, ' ');
        day = ('00' + day).slice(-2).replace(/^0/, ' ');

        const wareki = this.convertToWareki(year,month,day);
        const warekiYear = parseInt(year) - wareki.startYear + 1;
        return `${wareki.era}${warekiYear}年${month}月${day}日`;
      },
      convertToWareki(year,month,day) {
        // 令和：2019年5月1日以降
        if (year >= 2019) {
          return { era: '令和', startYear: 2019 };
        }
        else if (year >= 1989) {
        // 平成：1989年1月8日以降
          if (year == 1989 && month == 1 && day <= 7) {
              return { era: '昭和', startYear: 1926 };
          } else {
              return { era: '平成', startYear: 1989 };
          }
        }
        else if (year >= 1926) {
          return { era: '昭和', startYear: 1926 };
        }
        else if (year >= 1912) {
          return { era: '大正', startYear: 1912 };
        }
        else {
          return { era: '明治', startYear: 1868 };
        }
      },
      setDanchoNo() {
        var val = this.ledgerData.issue.date;
        
        const url = apiUrl('KisaiNo') + '?date=' + val;
        const self = this;
        callGetApi(url, (data) => {
          if (data.errorCode === undefined) {
            //self.ledgerData.issue.no = "11"+String(data-11000);
            var v = (data % 11000).toString();
            self.ledgerData.issue.no = "11"+v.padStart(3, '0');
          }
        });
      },
      setValue(value) {
        // return value !== null ? parseFloat(value).toFixed(2) : '-';
        const num = parseFloat(value);
        // return !isNaN(num) ? num.toFixed(2) : '-';
        return !isNaN(num) ? num : '-';
      },

    }
  }
  
</script>

<style lang="scss" scoped>
  .split {
    position: absolute;
    width: 100%;
    height: calc(100% - 6px);
    padding: 0.3em 0;
    margin: 0;
    overflow: hidden;
  }
  .left-box {
    left: 0;
    width: 25%;
    min-width: 200px;
    height: calc(100% - 20px);
    padding: 0.3em;
    overflow-y: auto;
  }
  .right-box {
    right: 0;
    width: 75%;
    height: calc(100% - 20px);
    padding: 0 0.5em;
    overflow-y: scroll;
    overflow-x: auto;
    background-color: rgb(198, 226, 225);
  }
  .active {
    background-color: aquamarine;
  }
  
  h1 {
    font-weight: normal;
    text-align: center;
    color: #448888;
    background-color: #ffccaa;
  }
  .dialog-title {
    color: #ff2222;
  }
  .custom-dialog {
    width: 200px;
    background-color: #f5f5f5; /* 背景色を変更 */
    border-radius: 10px; /* 角を丸くする */
    padding: 20px; /* 内側の余白を追加 */
  }
  .custom-btn {
    height: 70px !important; /* 高さを調整 */
    width: 50%;
    display: flex !important;
    align-items: center !important; /* 縦軸中央に配置 */
    justify-content: center !important; /* 水平中央に配置 */
    font-size: 16px !important; /* 文字サイズを調整 */
    padding: 20px !important
  }
  @media print {
    .left-box {
      width: 0;
      visibility: hidden;
    }
    .right-box {
      width: 200mm;
      margin: 0;
      padding: 0;
      overflow: hidden;
    }
  }
</style>
